import { WorkStepCreationOptions } from "./components/WorkStepCreationOptions";

// Landing page for "Create New Work Step": entry cards, mirroring
// CreateControlChooserPage. The manual/AI creation form lives one step
// deeper at /audit/work-steps/create/manual.
export const CreateWorkStepChooserPage = () => {
  return (
    <div className="h-screen overflow-y-auto w-full px-6">
      <WorkStepCreationOptions
        title="Create New Work Steps"
        subtitle="Bulk import from Optro, or build work steps yourself. Your work step data already lives in Optro's audits and carries over automatically."
      />
    </div>
  );
};

export default CreateWorkStepChooserPage;
